// removed by extract-text-webpack-plugin
module.exports = {"this":"_1slpGXeI2EpWMFzC_uc_G9","mintIndicatorWrapper":"_2ZLjjQhC7TVsXtJF3sxEAS","mintIndicatorSpin":"_1IfjUazdBIxoM00r4vB0_e","mintIndicatorText":"_1-w6PeFTca5IdzAo9cn4gq","shade":"_3z2xefkie-Wqx4_gmZs7Pn"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/Error.scss
// module id = 605
// module chunks = 12